import React from "react";

const RippleLoader = ({
  width = "w-full",
  height = "h-4",
  backgroundColor = "bg-[#afb6b9]/20",
}) => {
  return (
    <div
      className={`relative overflow-hidden ${width} ${height} ${backgroundColor} rounded-full`}
    >
      <div className="absolute inset-0">
        <div className="animate-ripple absolute inset-0 transform translate-x-full bg-gradient-to-r from-transparent via-white to-transparent"></div>
      </div>
    </div>
  );
};

export default RippleLoader;
